
import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import { FaEnvelope, FaMicrosoft, FaAt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { baseURL } from "../../../Utils/constants/constant";
import axios from "axios";
import { PostRequest } from "../../../Utils/hooks/ApiHandler";

export default function EmailSettings() {
  const navigate = useNavigate();


  const GMAIL_CLIENT_ID =
    "791656083371-20fe92r5aq46otpm37miktc966919gfv.apps.googleusercontent.com";
  const GMAIL_REDIRECT_URI = "http://localhost:3000/email-settings";
  const GMAIL_SCOPE =
    "email profile https://www.googleapis.com/auth/gmail.modify https://www.googleapis.com/auth/gmail.labels https://www.googleapis.com/auth/gmail.send";

  const OUTLOOK_CLIENT_ID = "05621bb9-499c-4315-b87a-44d3a670c68f";
  const OUTLOOK_REDIRECT_URI = "http://localhost:3000/email-settings";
  const OUTLOOK_SCOPE =
    "openid profile email offline_access https://graph.microsoft.com/Mail.ReadWrite https://graph.microsoft.com/Mail.Send";

  const AUTHORITY = "https://login.microsoftonline.com/common";

 
  const gmailLoginUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GMAIL_CLIENT_ID}&redirect_uri=${encodeURIComponent(
    GMAIL_REDIRECT_URI
  )}&scope=${encodeURIComponent(
    GMAIL_SCOPE
  )}&response_type=token&prompt=consent`;

  const outlookLoginUrl =
  `${AUTHORITY}/oauth2/v2.0/authorize?` +
  `client_id=${OUTLOOK_CLIENT_ID}` +
  `&response_type=code` +
  `&response_mode=query` +
  `&prompt=select_account` + 
  `&redirect_uri=${encodeURIComponent(OUTLOOK_REDIRECT_URI)}` +
  `&scope=${encodeURIComponent(OUTLOOK_SCOPE)}`;


  const [token, setToken] = useState(
    sessionStorage.getItem("email_access_token")
  );
  const [service, setService] = useState(
    sessionStorage.getItem("email_service")
  );

 
  const handleGmailLogin = () => {
    sessionStorage.clear();
    window.location.href = gmailLoginUrl;
  };

  const handleOutlookLogin = () => {
    sessionStorage.clear();
    window.location.href = outlookLoginUrl;
  };

  const handleDisconnect = () => {
    sessionStorage.clear();
    setToken(null);
    setService(null);
    toast.success("Disconnected");
  };

useEffect(() => {
  const run = async () => {
    const params = new URLSearchParams(window.location.search);
    const outlookCode = params.get("code");   
    const hash = window.location.hash;

   
    if (hash && hash.includes("access_token")) {
      const p = new URLSearchParams(hash.substring(1));
      const accessToken = p.get("access_token");
      const expiresIn = p.get("expires_in");

      if (accessToken && expiresIn) {
        sessionStorage.setItem("email_access_token", accessToken);
        sessionStorage.setItem("email_service", "gmail");
        sessionStorage.setItem(
          "email_token_expiry",
          Date.now() + Number(expiresIn) * 1000
        );

        toast.success("Gmail connected");
        window.history.replaceState({}, document.title, "/email-settings");
        navigate("/testing", { replace: true });
        return;
      }
    }

    if (outlookCode) {
  try {
    const res = await PostRequest(
      `${baseURL}inbox/token`,
      { code: outlookCode },
      false,
      {},
      {}
    );


    if (res.status === "success" && res.data?.access_token) {
      sessionStorage.setItem("email_access_token", res.data.access_token);
      sessionStorage.setItem("email_refresh_token", res.data.refresh_token);
      sessionStorage.setItem("email_service", "outlook");

      toast.success("Outlook connected");

      window.history.replaceState({}, document.title, "/email-settings");
      navigate("/testing", { replace: true });
    } else {
      toast.error("Outlook connect failed");
    }
  } catch (e) {
    console.error(e);
    toast.error("Outlook connect failed");
  }
}
  };

  run();
}, [navigate]);


  return (
    <div className="p-4" style={{ backgroundColor: "#f5f6fa", minHeight: "100vh" }}>
      <Row className="mb-3">
        <Col>
          <h5>COMMUNICATION / EMAIL SETTINGS</h5>
        </Col>
        <Col className="text-end">
          <Button variant="secondary" onClick={() => navigate("/testing")}>
            Back to Emails
          </Button>
        </Col>
      </Row>

      <Card className="p-4">
        {!token ? (
          <Row className="text-center">
            <Col>
              <Card onClick={handleGmailLogin} className="p-3 clickable">
                <FaEnvelope size={40} color="#d93025" />
                <h6>Gmail</h6>
              </Card>
            </Col>
            <Col>
              <Card onClick={handleOutlookLogin} className="p-3 clickable">
                <FaMicrosoft size={40} color="#0078d4" />
                <h6>Outlook</h6>
              </Card>
            </Col>
            <Col>
              <Card className="p-3">
                <FaAt size={40} />
                <h6>Others</h6>
              </Card>
            </Col>
          </Row>
        ) : (
          <>
            <p className="text-success">
              {service === "gmail" ? "Gmail" : "Outlook"} connected 
            </p>
            <Button variant="danger" onClick={handleDisconnect}>
              Disconnect
            </Button>
          </>
        )}
      </Card>
    </div>
  );
}
